import React, { useState, useEffect, useCallback } from 'react';
import { signUp } from '../services/ApiServices';
import { useNavigate } from 'react-router-dom';
import ToastMsg from '../component/comman/ToastMsg';

const Signup = ({ toggleAuthMode }) => {
  const navigate = useNavigate();
  const [userInput, setUserInput] = useState({
    firstName: '',
    lastName: '',
    companyName: '',
    email: '',
    mobileNo: '',
    password: '',
    isLoader: false,
  });

  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});

  const validateForm = useCallback(() => {
    const newErrors = {};
    if (!userInput.firstName.trim()) newErrors.firstName = 'First Name is required';
    if (!userInput.lastName.trim()) newErrors.lastName = 'Last Name is required';
    if (!userInput.companyName.trim()) newErrors.companyName = 'Company Name is required';
    if (!userInput.email.trim()) newErrors.email = 'Email is required';
    else if (!/\S+@\S+\.\S+/.test(userInput.email)) newErrors.email = 'Email is invalid';
    if (!userInput.mobileNo.trim()) {newErrors.mobileNo = 'Enter Valid Mobile Number';
    } else if (!/^\d{10,12}$/.test(userInput.mobileNo)) {newErrors.mobileNo = 'Mobile Number must be 10 digits';}
    if (!userInput.password.trim()) newErrors.password = 'Password is required';
    else if (userInput.password.length < 8) newErrors.password = 'Password must be more than 9 characters';
    
    setErrors(newErrors);
  }, [userInput, setErrors]);
  
  useEffect(() => {
    validateForm();
  }, [validateForm]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUserInput({
      ...userInput,
      [name]: value,
    });
    setTouched({
      ...touched,
      [name]: true,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm() === true) {
      console.log("hello");
      return;
    }
    if (userInput.isLoader) return;
    const params = {
      first_name: userInput.firstName,
      last_name: userInput.lastName,
      company_name: userInput.companyName,
      email: userInput.email,
      mobile_no: userInput.mobileNo,
      password: userInput.password,
    };

    setUserInput({
      ...userInput,
      isLoader: true,
    });

    signUp(params).then((res) => {
        if (res.status === 201) {
          console.log(res, 'Signup successful');
          localStorage.setItem('accessToken', res.data.tokens.access);
          localStorage.setItem('role', res.data.user_role);
          window.location.href="/report"
        }
      })
      .catch((err) => {
        setUserInput({
          ...userInput,
          isLoader: false,
        });
        if (err.response?.status === 401) {
          navigate("/")
        }
        let error = err?.response?.data?.error || "something went wrong";
        ToastMsg(error, "error");
      });
  };

  return (
    <div className='signup-wrapper d-flex justify-content-center align-items-center'>
      <div className='signup-inner'>
        {/* <h2 className='mb-2'>Balanceko</h2> */}
        <h2 className='mb-2'>Create account</h2>
        <p className='pb-50'>Already have an account?<span onClick={toggleAuthMode}>Login</span></p>
        <form onSubmit={handleSubmit}>
          <div className="form-group mb-4">
            <input
              type="text"
              name="firstName"
              className="form-control"
              placeholder="First Name"
              value={userInput.firstName}
              onChange={handleInputChange}
              onBlur={() => setTouched({ ...touched, firstName: true })}
              autoComplete="off"
            />
            {touched.firstName && errors.firstName && <span className="text-danger">{errors.firstName}</span>}
          </div>
          <div className="form-group mb-4">
            <input
              type="text"
              name="lastName"
              className="form-control"
              placeholder="Last Name"
              value={userInput.lastName}
              onChange={handleInputChange}
              onBlur={() => setTouched({ ...touched, lastName: true })}
              autoComplete="off"
            />
            {touched.lastName && errors.lastName && <span className="text-danger">{errors.lastName}</span>}
          </div>
          <div className="form-group mb-4">
            <input
              type="text"
              name="companyName"
              className="form-control"
              placeholder="Company Name"
              value={userInput.companyName}
              onChange={handleInputChange}
              onBlur={() => setTouched({ ...touched, companyName: true })}
              autoComplete="off"
            />
            {touched.companyName && errors.companyName && <span className="text-danger">{errors.companyName}</span>}
          </div>
          <div className="form-group mb-4">
            <input
              type="email"
              name="email"
              className="form-control"
              placeholder="Enter email"
              value={userInput.email}
              onChange={handleInputChange}
              onBlur={() => setTouched({ ...touched, email: true })}
              autoComplete="off"
            />
            {touched.email && errors.email && <span className="text-danger">{errors.email}</span>}
          </div>
          <div className="form-group mb-4">
            <input
              type="number"
              name="mobileNo"
              className="form-control"
              placeholder="Mobile Number"
              value={userInput.mobileNo}
              onChange={handleInputChange}
              onBlur={() => setTouched({ ...touched, mobileNo: true })}
              autoComplete="off"
            />
            {touched.mobileNo && errors.mobileNo && <span className="text-danger">{errors.mobileNo}</span>}
          </div>
          <div className="form-group mb-4">
            <input
              type="password"
              name="password"
              className="form-control"
              placeholder="Password"
              value={userInput.password}
              onChange={handleInputChange}
              onBlur={() => setTouched({ ...touched, password: true })}
              autoComplete="off"
            />
            {touched.password && errors.password && <span className="text-danger">{errors.password}</span>}
          </div>
          <button type="submit" className="btn w-100">
            Create Account
          </button>
        </form>
      </div>
    </div>
  );
};

export default Signup;